export default __webpack_public_path__ + "static/media/chat-bg.5224f2bf.png";